import React from 'react'

import NotDataImage from '../../Images/imagenotdata.jpg'
import moment from 'moment';
import { Tooltip } from '@mui/material';
import PaginationPage from '../../TablePagination';

// let rolesData = window.sessionStorage.getItem('rolesData');


const UiTable = ({ disable, paginationHandlerNew, actionHandler, allData, DetailHandler, totalCount, paginationHandler,
    pageNumber, noOfRows, sortinghandler, commentHandler, openAssignmentPopup, openEmpAssignmentPopup, commentValueToShow, empData, openEmpAssignmentPopupLender, lenderEmpData }) => {

    let colors = [
        {
            code: 1,
            color: '#ffbebe'
        },
        {
            code: 2,
            color: '#ff9b9b'
        },
        {
            code: 3,
            color: 'rgb(237 105 105)'
        },
    ]

    const findEmp = (key) => {
        if (empData && key) {
            var filterData = empData.filter(item => item.code === key);
            return filterData.length > 0 ? filterData[0].name : ""
        }
    }

    const findColor = (key) => {
        if (colors && key) {
            var filterData = colors.filter(item => item.code === key);
            return filterData
        }
    }

    const findEmpLender = (key) => {

        if (lenderEmpData && key) {
            var filterData = lenderEmpData.filter(item => item.code === key);
            return filterData.length > 0 ? filterData[0].name : ""
        }
    }
    const getLenderRes = (lender) => {
        let res = ''
        if (lender) {
            if (lender.length > 1) {
                res = lender[0] ? lender[0].lenderCompanyName + ',...' : ""
            } else (
                res = lender[0] ? lender[0].lenderCompanyName : ""
            )
        }
        return res;
    }

    const getLenderTitle = (lenders) => {
        let res = ''
        if (lenders) {
            lenders.map((data, i) => {
                return (
                    res = res + data.lenderCompanyName + ", "
                )
            })
        }
        return res ? res.substring(0, res.length - 2) : ""
    }

    return (
        <div className='table-responsive '>
            {allData.length > 0 ?
                <>
                    <div style={{ overflowX: 'auto' }}>
                        <table className='table credhub-table' style={{borderCollapse:'collapse'}}>
                            <thead>
                                <tr>
                                    {/* {window.location.href.includes('admin/leads') ? */}
                                    {/* <><th>Lenders Assigned</th>
                                        <th>Assigned To</th>
                                        <th>Alias</th></> */}
                                    {/* : ""} */}
                                    {/* {window.location.href.includes('lender/leads') && window.sessionStorage.getItem("lenderEmployeeId") === '' ? */}
                                    {/* <th>Assign To</th> */}
                                    {/* : ""} */}
                                    {/* <th scope="col">Community</th> */}

                                    <th scope="col">Info</th>
                                    <th scope="col">View</th>
                                    {/* {rolesData && rolesData.includes("comments") ? */}
                                    {/* {rolesData && rolesData.includes("comments") ? */}
                                    {/* <th scope='col'><i className='fa fa-comments-o' style={{ fontSize: '16px' }}></i></th> */}
                                    {/* : ""} */}

                                    <th scope="col" style={{ cursor: 'pointer' }} onClick={() => sortinghandler()}>
                                        <span>Name</span>
                                        <i className='fa fa-sort table-sort' />
                                    </th>

                                    {/* <th scope="col">Email Id</th> */}
                                    <th scope="col">Application Id</th>

                                    {/* <th scope="col">Mobile Number</th> */}
                                    {/* <th scope="col">State</th> */}
                                    <th scope="col">City</th>
                                    {/* <th scope="col">Account Number</th> */}
                                    <th scope="col">Amount</th>
                                    <th scope='col'>Loan Status</th>
                                    <th scope="col">Tenure</th>
                                    <th scope='col'>Apply date</th>
                                    <th scope='col'>Loan Type</th>

                                    {/* <th scope="col">Esign</th>
                                    <th scope="col">Enach</th> */}
                                    {/* {rolesData && rolesData.includes("comments") ?
                                        <th scope="col">Comments</th>
                                        : ""} */}
                                    {/* {window.location.href.includes('admin') ? */}
                                    {/* <th scope="col">Edit & Delete</th> */}
                                    {/* : window.location.href.includes('community') ||
                                            rolesData && rolesData.includes("lenderEditLead") ?
                                            <th scope="col">Edit </th> : ''} */}
                                </tr>
                            </thead>
                            <tbody>
                                {allData.map((row, i) => {
                                    let color = ""
                                    // if (window.location.href.includes('admin/leads')) {
                                    //     color = findColor(row.mostRemindedCommentCount)
                                    // }
                                    return (
                                        <tr key={i} style={{ backgroundColor: color ? color[0].color : "", color: "black" }}>
                                            {/* {window.location.href.includes('admin/leads') ?
                                                <> */}
                                                    {
                                                        // (getLenderRes(row.respInt)).includes('...') ?
                                                        //     <Tooltip title={getLenderTitle(row.respInt)}><td onClick={() => openAssignmentPopup('open', row.loanId, row.respInt)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                                                        //         {getLenderRes(row.respInt)}</td>
                                                        //     </Tooltip> :
                                                        //     <td onClick={() => openAssignmentPopup('open', row.loanId, row.respInt)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                                                        //         {getLenderRes(row.respInt)}</td>
                                                    }
                                                    {/* <td onClick={() => openEmpAssignmentPopup('open', row.loanId)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>{findEmp(row.employeeId)}</td> */}
                                                    {/* </>
                                                : ""} */}
                                            {/* {window.location.href.includes('admin/leads') ? */}
                                                {/* <td>{row.aliasName}</td> */}
                                                {/* : ""} */}
                                            {/* {
                                                window.location.href.includes('lender/leads') && window.sessionStorage.getItem("lenderEmployeeId") === '' ? */}

                                                    {/* <td onClick={() => openEmpAssignmentPopupLender('open', row.loanId)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>{findEmpLender(row.employeeId)}</td> */}

                                                    {/* : ""
                                            } */}
                                            {/* <td>{row.communityName}</td> */}
                                            <td>
                                                <i className='fa fa-info-circle pointer' onClick={e => DetailHandler(row)} />
                                            </td>
                                            <td><span class="fa fa-eye" onClick={e => actionHandler('view', row)}></span></td>
                                            {/* {rolesData && rolesData.includes("comments") ? */}
                                                {/* <td><button class="fa fa-comments-o" onClick={E => DetailHandler(row, "comment")} style={{ fontSize: '16px' }}>{row.unReadComments ? <span class="badge label-default" style={{ fontSize: "9px" }}>{row.unReadComments}</span> : ""}</button></td> */}
                                                {/* : ""} */}
                                            <td>{row.name}</td>

                                            {/* <td>{row.emailId}</td> */}
                                            <td>{row.applicationId}</td>
                                            {/* <td>{row.mobileNo}</td> */}
                                            {/* <td>{row.state}</td> */}
                                            <td>{row.city}</td>
                                            {/* <td>{row.accountNo}</td> */}
                                            <td>{row.loanAmount}</td>
                                            <td>{row.loanStatus}</td>
                                            <td>{row.tenure}</td>
                                            <td>{row.applyDate ? moment(row.applyDate).format("DD-MM-YYYY") : ""} </td>
                                            <td>{row.loanType}</td>
                                            {/* <td>{row.esignStatus ? <i className='fa fa-check' style={{ color: 'green' }}></i> : <i className='fa fa-close' style={{ color: 'red' }}></i>}</td>
                                            <td>{row.nachStatus ? <i className='fa fa-check' style={{ color: 'green' }}></i> : <i className='fa fa-close' style={{ color: 'red' }}></i>}</td> */}
                                            {/* {console.log('commentValueToShow',commentValueToShow,row)} */}
                                            {/* {rolesData && rolesData.includes("comments") ?
                                                <td className='d-flex'>
                                                    <input value={commentValueToShow && commentValueToShow.includes(row.loanId) ? commentValueToShow.split(',')[0] : ''} type="text" onChange={(e) => commentHandler(e, 'input', row.loanId)} />
                                                    <button type='button' className="cred-btn center-block" onClick={(e) => commentHandler(e, 'button', row)}><i className='fa fa-save'></i></button></td>
                                                : ""} */}

                                            {/* {window.location.href.includes('admin') ? */}
                                            {/* {
                                                window.location.href.includes('community') || */}
                                                    {/* rolesData && rolesData.includes("lenderEditLead") ? */}
                                                    {/* <td>
                                                        <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                            <i className='fa fa-edit' />
                                                        </button>
                                                    </td>
                                                    : window.location.href.includes('admin') ? */}
                                                        {/* <td>
                                                            <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                <i className='fa fa-edit' />
                                                            </button>
                                                           
                                                                <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                                    <i className='fa fa-trash-o' />
                                                                </button>
                                                             
                                                        </td> */}
                                                         {/* : ''} */}
                                            {/* : ""} */}
                                            {/* <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                    <i className='fa fa-trash-o' />
                                                </button> */}

                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <PaginationPage
                        paginationHandlerNew={paginationHandlerNew}
                        totalCount={totalCount}
                        paginationHandler={paginationHandler}
                        pageNumber={pageNumber}
                        noOfRows={noOfRows}
                    />

                </>
                : <div className='text-center'><img src={NotDataImage} style={{ width: '50%' }} /></div>}
        </div>
        // </div>
    )
}

export default UiTable;